import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { OnboardingState } from '../../types/Onboarding';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/onboarding', 'get'>;

type Result = OnboardingState;

export const getOnboardingFactory = (apiClient: ApiClient) => {
  const getOnboarding = async () => {
    const response = await apiClient['/api/onboarding'].get();
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      isOnboardingFinished: response.isOnboardingFinished,
      onboardingCheckList: response.onboardingCheckList,
    };
  };

  return getOnboarding;
};
